var _ = require("underscore");

/**
 * Quota permet d'interpréter la syntaxe de quota d'impression utilisé chez immanens
 * ex: 10/1w pour dire 10 impressions autorisées par tranche d'une semaine, avec remise à zéro le lundi 00:00
 */
module.exports = {

    /**
     * Calcule quelle sera la date de la prochaine remise à 0 en fonction de la période passée et de la date courante
     */
    computeResetDate: function (period) {

        // analyse de la syntaxe : doit commencer par un nombre et doit finir par une lettre parmi m, w, d, h
        var unit = period.slice(-1);
        var number_of_unit = parseInt(period.substr(0, period.length - 1));

        var today = new Date();
        var reset_date = new Date();
        var dd = today.getDate();
        var mm = today.getMonth(); //January is 0!

        if (unit == "m") {
            // recherche du début du X mois suivant
            reset_date.setDate(1);
            reset_date.setMonth(mm + number_of_unit);
            reset_date.setHours(0, 0, 0, 0);
        }
        else if (unit == "w") {
            // week
            reset_date = getMonday(today);
            reset_date.setDate(reset_date.getDate() + number_of_unit * 7);
            reset_date.setHours(0, 0, 0, 0);
        }
        else if (unit == "d") {
            // day
            reset_date.setDate(dd + number_of_unit);
            reset_date.setHours(0, 0, 0, 0);
        }
        else if (unit == "h") {
            // hour
            var hh = today.getHours();
            reset_date.setHours(hh + number_of_unit, 0, 0, 0);
        }
        else {
            throw (new Error("unsupported period unit " + unit));
        }

        return reset_date;
    },

    counterFromString: function (config_string) {
        return parseInt(config_string.split("/")[0]);
    },

    periodFromString: function (config_string) {
        return config_string.split("/")[1];
    },

    /**
     * retourne un tableau de pages à partir d'une string d'impression
     * page syntax : 1-5, 8, 11-13
     */
    pagesFromString: function (pages_string, nbPagesMax, separator) {
        var pages = [];
        separator = separator || ",";
        var page_spl = pages_string.split(separator);

        page_spl.forEach(function (page_interval) {
            var page_interval_spl = page_interval.split("-");
            if (page_interval_spl.length == 1) {
                var page = parseInt(page_interval_spl[0]);
                pages.push(page);
            }
            else if (page_interval_spl.length > 1) {
                var page_min = parseInt(page_interval_spl[0]);
                if (page_min < 0) {
                    page_min = 1;
                }
                var page_max = parseInt(page_interval_spl[1]);

                if (page_max < page_min) {
                    page_max = page_min;
                }
                if (page_max - page_min > nbPagesMax - 1) {
                    page_max = page_min + nbPagesMax - 1;
                }

                for (var i = page_min; i <= page_max; i++) {
                    pages.push(i);
                }
            }
        });

        pages = _.uniq(pages);
        pages = pages.sort(function (a, b) {
            return a - b;
        });
        pages = pages.slice(0, nbPagesMax);

        return pages;
    },

    /**
     * vérifie que la syntaxe est correcte et qu'elle ne dépasse pas le nombre max de page
     */
    checkPrintRangeSyntax: function (page_str, max_page) {
        if (page_str.length) {
            var page_spl = page_str.split(",");
            for (var i = 0; i < page_spl.length; i++) {
                var page_interval = page_spl[i];
                var page_interval_spl = page_interval.split("-");
                if (page_interval_spl.length == 1) {
                    var page = parseInt(page_interval_spl[0]);
                    if (isNaN(page) || page < 1 || page > max_page) {
                        return false;
                    }
                } else if (page_interval_spl.length == 2) {
                    var page_min = parseInt(page_interval_spl[0]);
                    var page_max = parseInt(page_interval_spl[1]);
                    if (isNaN(page_min) || page_min < 1 || page_min > max_page) {
                        return false;
                    }
                    if (isNaN(page_max) || page_max < 1 || page_max > max_page) {
                        return false;
                    }
                    if (page_min > page_max) {
                        return false;
                    }
                } else {
                    return false;
                }
            }
        } else {
            return false;
        }
        return true;
    },

    /**
     * inverse la série de page pour les documents arabes, la syntaxe devra être valide
     */
    reversePrintRange: function (page_str, nb_pages) {
        if (page_str && page_str.length) {
            var page_spl = page_str.split(",");
            var reversed_page_str = "";
            for (var i = 0; i < page_spl.length; i++) {
                var page_interval = page_spl[i];
                var page_interval_spl = page_interval.split("-");
                if (page_interval_spl.length == 1) {
                    var page = parseInt(page_interval_spl[0]);
                    if (reversed_page_str.length) {
                        reversed_page_str = "," + reversed_page_str;
                    }
                    reversed_page_str = String(nb_pages - page + 1) + reversed_page_str;
                } else if (page_interval_spl.length == 2) {
                    var page_min = parseInt(page_interval_spl[0]);
                    var page_max = parseInt(page_interval_spl[1]);
                    if (reversed_page_str.length) {
                        reversed_page_str = "," + reversed_page_str;
                    }
                    reversed_page_str = String(nb_pages - page_max + 1) + "-" + String(nb_pages - page_min + 1) + reversed_page_str;
                }
            }
            page_str = reversed_page_str;
        }
        return page_str;
    }

};

/**
 * retourne le lundi précédent la date en argument
 */
function getMonday(d) {
    d = new Date(d);
    var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/reader/lib/quota.js
// module id = 47
// module chunks = 0